/**
 * Platform-portable Express tracing integration.
 *
 * @module
 *
 * This Sentry integration is a derivative work based on the OpenTelemetry
 * Express instrumentation.
 *
 * <https://github.com/open-telemetry/opentelemetry-js-contrib/tree/main/packages/instrumentation-express>
 *
 * Extended under the terms of the Apache 2.0 license linked below:
 *
 * ----
 *
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { ExpressRequest } from './types';

// map of patched request objects to stored layers
const requestLayerStore = new WeakMap<ExpressRequest, string[]>();
export const storeLayer = (req: ExpressRequest, layer: string) => {
  const store = requestLayerStore.get(req);
  if (!store) {
    requestLayerStore.set(req, [layer]);
  } else {
    store.push(layer);
  }
};

export const getStoredLayers = (req: ExpressRequest) => {
  let store = requestLayerStore.get(req);
  if (!store) {
    store = [];
    requestLayerStore.set(req, store);
  }
  return store;
};



// WEBPACK FOOTER //
// ../../../../src/integrations/express/request-layer-store.ts